import EmailCapture from 'components/EmailCapture';

function Newsletter(props) {
  return <EmailCapture {...{ cmsData: props }} />;
}

export default Newsletter;
